module.exports = __webpack_public_path__ + "img/charman2.52f11e6b.png";